import { render, staticRenderFns } from "./ArticleDirectoryList.vue?vue&type=template&id=0b94574b&scoped=true&"
import script from "./ArticleDirectoryList.vue?vue&type=script&lang=js&"
export * from "./ArticleDirectoryList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDirectoryList.vue?vue&type=style&index=0&id=0b94574b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94574b",
  null
  
)

export default component.exports